module.exports = __webpack_public_path__ + "static/media/cases_anuncios_02c.7ff96196.jpg";